import React from 'react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { ArrowRight, Zap, RefreshCw, Compass, Maximize } from 'lucide-react';
export function AdvisorySection() {
  const services = [{
    title: 'Scale Revenue',
    description: 'Implement predictable, repeatable revenue engines that drive sustainable growth.',
    icon: <Maximize className="w-5 h-5 text-gold" data-id="element-20" />
  }, {
    title: 'Restructure Sales Teams',
    description: 'Optimize organizational design, compensation, and talent to maximize performance.',
    icon: <RefreshCw className="w-5 h-5 text-gold" data-id="element-21" />
  }, {
    title: 'Build GTM Strategies',
    description: 'Design comprehensive go-to-market plans for new products or market segments.',
    icon: <Compass className="w-5 h-5 text-gold" data-id="element-22" />
  }, {
    title: 'Accelerate Expansion',
    description: 'Identify and execute on channel, geographic, and enterprise partnership opportunities.',
    icon: <Zap className="w-5 h-5 text-gold" data-id="element-23" />
  }];
  return <section id="advisory" className="py-24 bg-navy-950 relative overflow-hidden" data-id="element-24">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 h-3/4 bg-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-25"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-26">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-27">
          <div data-id="element-28">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-gold/10 text-gold text-sm font-medium mb-6 border border-gold/20" data-id="element-29">
              HyRoad Consulting
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-30">
              Strategic Advisory & <br data-id="element-31" />
              <span className="text-gradient" data-id="element-32">Fractional CRO</span>
            </h2>
            <p className="text-lg text-white/50 mb-8 leading-relaxed" data-id="element-33">
              I partner with founders, boards, and executive teams to solve
              complex commercial challenges. Whether you need a strategic
              overhaul or interim executive leadership, I provide the expertise
              to accelerate your growth trajectory.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10" data-id="element-34">
              {services.map((service, index) => <div key={index} className="flex gap-4" data-id="element-35">
                  <div className="mt-1 w-10 h-10 rounded-lg bg-navy-800 flex items-center justify-center flex-shrink-0" data-id="element-36">
                    {service.icon}
                  </div>
                  <div data-id="element-37">
                    <h4 className="font-semibold text-white mb-1" data-id="element-38">
                      {service.title}
                    </h4>
                    <p className="text-sm text-white/50" data-id="element-39">
                      {service.description}
                    </p>
                  </div>
                </div>)}
            </div>

            <Button onClick={() => {
            window.location.hash = '#/contact';
          }} data-id="element-40">
              Discuss an Engagement
              <ArrowRight className="ml-2 w-4 h-4" data-id="element-41" />
            </Button>
          </div>

          <div className="relative" data-id="element-42">
            <Card className="p-8 md:p-10 border border-navy-600/50 bg-navy-800/50 backdrop-blur-xl" data-id="element-43">
              <h3 className="text-2xl font-bold text-white mb-6" data-id="element-44">
                Ideal Partnerships
              </h3>
              <ul className="space-y-6" data-id="element-45">
                <li className="flex items-start gap-4" data-id="element-46">
                  <div className="w-6 h-6 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-47">
                    <div className="w-2 h-2 rounded-full bg-gold" data-id="element-48"></div>
                  </div>
                  <div data-id="element-49">
                    <h4 className="font-semibold text-white/90" data-id="element-50">
                      PE/VC-Backed Portfolios
                    </h4>
                    <p className="text-sm text-white/50 mt-1" data-id="element-51">
                      Companies requiring rapid commercial transformation or
                      scale post-investment.
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-4" data-id="element-52">
                  <div className="w-6 h-6 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-53">
                    <div className="w-2 h-2 rounded-full bg-gold" data-id="element-54"></div>
                  </div>
                  <div data-id="element-55">
                    <h4 className="font-semibold text-white/90" data-id="element-56">
                      High-Growth Startups
                    </h4>
                    <p className="text-sm text-white/50 mt-1" data-id="element-57">
                      Organizations transitioning from founder-led sales to
                      structured revenue teams.
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-4" data-id="element-58">
                  <div className="w-6 h-6 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-59">
                    <div className="w-2 h-2 rounded-full bg-gold" data-id="element-60"></div>
                  </div>
                  <div data-id="element-61">
                    <h4 className="font-semibold text-white/90" data-id="element-62">
                      Stalled Enterprises
                    </h4>
                    <p className="text-sm text-white/50 mt-1" data-id="element-63">
                      Established businesses needing go-to-market revitalization
                      or new channel strategies.
                    </p>
                  </div>
                </li>
              </ul>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}